<template lang="pug">
fieldset(:disabled="loading")
  form.pt-2(@submit.prevent="save")
    modal(active, title='Editar percentuais do afiliado', @close='$router.back()')
      div(slot='modal-body')
        cite Este valor sobrescreverá o repasse de ganhos padrão definidos nos parâmetros do sistema.
        .text-bold Este processo é necessário caso deseje adicionar ganhos diferenciados para determinados afiliados.
        .mt-2(v-if="filiation")
          .divider
          span
            | Nome do afiliado:
            b  {{ filiation.person.fullName }}
        .divider
        .columns
          .column.col-6
            form-group(
              label="Percentual na assinatura"
              help="As assinaturas feitas a partir do link do afiliado renderão este percentual a ele"
            )
              masked-money.form-input(
                v-model="form.subscriptionPercentage"
                v-bind="{suffix: '%'}"
              )
            .form-group
              label.form-switch
                input(type="checkbox"  v-model="defaultSubscriptionPercentage")
                i.form-icon
                | Usar valor padrão
          .column.col-6
            form-group(
              label="Percentual na compra"
              help="As compras feitas a partir do link do afiliado renderão este percentual a ele"
            )
              masked-money.form-input(
                v-model="form.purchasePercentage"
                v-bind="{suffix: '%'}"
              )
            .form-group
              label.form-switch
                input(type="checkbox"  v-model="defaultPurchasePercentage")
                i.form-icon
                | Usar valor padrão
      div(slot="modal-footer")
        button.btn.btn-primary(:class="{loading}")
          i.fas.fa-check
          |  Salvar
</template>

<script>
import filiations from '@/services/filiations'
export default {
  props: ['filiation', 'refreshList'],
  data() {
    return {
      form: {
        subscriptionPercentage: null,
        purchasePercentage: null,
      },
      loading: false,
    }
  },
  computed: {
    defaultSubscriptionPercentage: {
      get() {
        return !this.form.subscriptionPercentage
      },
      set(v) {
        if (v) this.form.subscriptionPercentage = 0
      },
    },

    defaultPurchasePercentage: {
      get() {
        return !this.form.purchasePercentage
      },
      set(v) {
        if (v) this.form.purchasePercentage = 0
      },
    },
  },
  methods: {
    async save() {
      try {
        this.loading = true
        const { subscriptionPercentage, purchasePercentage } = this.form
        const body = {
          subscriptionPercentage: subscriptionPercentage
            ? subscriptionPercentage
            : null,
          purchasePercentage: purchasePercentage ? purchasePercentage : null,
        }
        await filiations.update(this.$route.params.id, body)
        this.$toaster.success('Percentuais do afiliado atualizados')
        this.refreshList()
        this.$router.back()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    if (this.filiation) {
      this.form.subscriptionPercentage = this.filiation.subscriptionPercentage
      this.form.purchasePercentage = this.filiation.purchasePercentage
    }
  },
}
</script>
